module.exports = __webpack_public_path__ + "static/media/Apr_2026_2.523e8919.webp";